export * from './breakpoints'
export * from './colors'
export * from './configuration'
//costanti per il css
export const green = '#008E8C'
export const red = '#a31d1d'
export const blue = '#115e8b'
export const defaultTextColor = '#000000'
export const tableTitleColor = '#d4d4d4'
